import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Environment-based portal selection
// REACT_APP_PORTAL=admin  → loads AdminApp (teacher's local server)
// REACT_APP_PORTAL=student or unset → loads StudentApp (deployed to Firebase)
const isAdmin = process.env.REACT_APP_PORTAL === 'admin';
const App = isAdmin
  ? require('./AdminApp').default
  : require('./StudentApp').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
